import React from "react";
import { Button, Container, Row, Col, Form, Accordion, Card, Tabs, Tab } from 'react-bootstrap';
import { Nav, ListGroup } from 'react-bootstrap';
import { context } from './AppContext';

export default class HorizontalTabs extends React.Component {
    render() {
        return (
            <Tab.Container id={this.props.id} defaultActiveKey={this.props.defaultActiveKey}>
                <Row style={{ height: '100%' }}>
                    <Col sm={3} style={{ height: '100%', overflowY: 'auto', paddingLeft: 0 }}>
                        <Nav variant="pills" className="flex-column">
                        {
                            this.props.tabs?.map((tab) => (
                                <Nav.Item key={tab.id}>
                                    <Nav.Link eventKey={"section_" + tab.id}>{ 
                                        tab.title 
                                    }</Nav.Link>
                                </Nav.Item>
                            ))
                        }
                        </Nav>
                    </Col>
                    <Col sm={9} style={{ height: '100%', overflowY: 'auto', padding: 0 }} >
                        <Tab.Content className="horizontal">
                            {
                                this.props.tabs?.map((tab) => (
                                    <Tab.Pane eventKey={"section_" + tab.id} key={tab.id}>
                                        { tab.content }
                                    </Tab.Pane>
                                ))
                            }
                        </Tab.Content>
                    </Col>
                </Row>
            </Tab.Container>
        );
    }
}